import React from "react";
import "./accordion.css";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { PEOPLE_ALSO_ASK } from "../../data/peopleAlsoAsk";

const AccordionComponent = () => {
  return (
    <div className="accordion-container">
      <div className="accordion-sub-container">
        <div style={{ width: "100%" }}>
          <h2 style={{ fontWeight: "normal", color: "var(--color-text)" }}>
            People also ask
          </h2>
          {PEOPLE_ALSO_ASK.map((qa, i) => (
            <Accordion key={i} defaultExpanded={i === 0}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "var(--color-text-light)" }} />}
                aria-controls={`panel${i}-content`}
                id={`panel${i}-header`}
              >
                <Typography sx={{ fontSize: 16, color: "var(--color-text)" }}>
                  {qa.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ color: "var(--color-text-medium)" }}>
                  {qa.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccordionComponent;
